import { render, staticRenderFns } from "./warehouseTaskChoice.vue?vue&type=template&id=5b0b5992&scoped=true"
import script from "./warehouseTaskChoice.vue?vue&type=script&lang=js"
export * from "./warehouseTaskChoice.vue?vue&type=script&lang=js"
import style0 from "./warehouseTaskChoice.vue?vue&type=style&index=0&id=5b0b5992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b5992",
  null
  
)

export default component.exports